var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullBlancoSinFondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "119.29720075046903 119.232 152.73545966228892 129.6",
    style: {
      maxHeight: 500
    },
    width: 152.73545966228892,
    height: 129.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.914 233h-4.221c-5.828 0-10.553-4.724-10.553-10.553V128h14.774v105zM258.714 233h-4.221c-5.828 0-10.553-4.724-10.553-10.553V128h14.774v105zM130.497 138.553c0-5.828 4.725-10.553 10.553-10.553h5.276v105h-15.829v-94.447z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.045 128v12.136h-14.774V128h14.774zM160.045 169.683v11.608H121v-11.608h39.045zM166.377 128h15.829v50.126h-15.829V128zM192.23 128h15.83v50.126h-15.83V128z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208.06 177.862c0 4.688-2.195 9.184-6.104 12.498-3.909 3.315-9.21 5.178-14.737 5.178-5.528 0-10.829-1.863-14.738-5.178-3.908-3.314-6.104-7.81-6.104-12.498h15.822c0 1.129.529 2.211 1.47 3.01.942.798 2.218 1.247 3.55 1.247 1.331 0 2.608-.449 3.549-1.247.941-.799 1.47-1.881 1.47-3.01h15.822z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBlancoSinFondo);
export default __webpack_public_path__ + "static/media/fullBlancoSinFondo.2b2d6e58285b93f5061d8b1b15da002b.svg";
export { ForwardRef as ReactComponent };